module.exports = __webpack_public_path__ + "static/Illustration-Taqueros-241db57f5a18ecb3c414f7732f1e420e.svg";